import React from "react"

import UnbilledSessions from "~Tutor/components/Sessions/UnbilledSessions"

const UnbilledSessionsPage = () => {
  return <UnbilledSessions />
}

export default UnbilledSessionsPage
